import { DefaultSeo as NextDefaultSeo } from "next-seo";
import { siteSettings } from "@settings/site-settings";
import { useTranslation } from "next-i18next";
export const DefaultSeo = () => {
  const {
    t
  } = useTranslation();
  return <NextDefaultSeo title={siteSettings.name} description={t('common:site-description')} openGraph={{
    type: "website",
    locale: "en_IE",
    site_name: siteSettings.name,
    images: [{
      url: `${siteSettings.author.websiteUrl}assets/images/og-image-01.png`,
      width: 800,
      height: 600,
      alt: `${siteSettings.name} Default Image`
    }]
  }} twitter={{
    handle: "@handle",
    site: "@site",
    cardType: "summary_large_image"
  }} additionalMetaTags={[{
    name: "viewport",
    content: "width=device-width, initial-scale=1, maximum-scale=1"
  }, {
    name: "apple-mobile-web-app-capable",
    content: "yes"
  }, {
    name: "theme-color",
    content: "#ffffff"
  }]} additionalLinkTags={[{
    rel: "apple-touch-icon",
    href: "/icons/apple-icon-180.png"
  }, {
    rel: "manifest",
    href: "/manifest.json"
  }]} data-sentry-element="NextDefaultSeo" data-sentry-component="DefaultSeo" data-sentry-source-file="default-seo.tsx" />;
};